import { gsap } from "gsap";
import { useEffect } from "react";

export function useDataWIdAnimation32() {
  useEffect(() => {
    gsap.set('[data-w-id="c4cea794-77f7-f49a-1bb8-004bfd8b670b"]', {"y": "10%"});
    gsap.set('[data-w-id="c4cea794-77f7-f49a-1bb8-004bfd8b670b"]', {"opacity": 0});
                const tl = gsap.timeline({"scrollTrigger": {"trigger": "[data-w-id=\"c4cea794-77f7-f49a-1bb8-004bfd8b670b\"]", "start": "top 70%", "end": "bottom top", "toggleActions": "play none none none", "once": true}});
      tl.addLabel("label0");
      tl.to('[data-w-id="c4cea794-77f7-f49a-1bb8-004bfd8b670b"]', {"duration": 0.5, "delay": 0.6, "ease": "power1.inOut", "y": "0%"}, "label0");
      tl.to('[data-w-id="c4cea794-77f7-f49a-1bb8-004bfd8b670b"]', {"duration": 0.5, "delay": 0.6, "ease": "power1.inOut", "opacity": 1}, "label0");
    return () => {
      tl.kill();
    };
  }, []);
}